type Color = 'green' | 'purple' | 'teal' | 'blue' | 'amber' | 'gray';

const COLOR_CLASSES: Record<Color, { bg: string; text: string; dot: string; hover: string }> = {
  green:  { bg: 'bg-green-100',  text: 'text-green-800',  dot: 'bg-green-500',  hover: 'hover:bg-green-200' },
  purple: { bg: 'bg-purple-100', text: 'text-purple-800', dot: 'bg-purple-500', hover: 'hover:bg-purple-200' },
  teal:   { bg: 'bg-teal-100',   text: 'text-teal-800',   dot: 'bg-teal-500',   hover: 'hover:bg-teal-200' },
  blue:   { bg: 'bg-blue-100',   text: 'text-blue-800',   dot: 'bg-blue-500',   hover: 'hover:bg-blue-200' },
  amber:  { bg: 'bg-amber-100',  text: 'text-amber-800',  dot: 'bg-amber-500',  hover: 'hover:bg-amber-200' },
  gray:   { bg: 'bg-gray-100',   text: 'text-gray-600',   dot: 'bg-gray-400',   hover: 'hover:bg-gray-200' },
};

import { useIsModuleEnabled } from '../hooks/useConfigVisibility';

interface EntityLinkButtonProps {
  label: string;
  onClick: () => void;
  color: Color;
  className?: string;
  /** module_visibility key of the link target; if that module is disabled, render nothing. */
  requireModule?: string;
}

/**
 * Colored pill navigation button with dot indicator.
 * Single source of truth for the "linked entity" navigation style
 * used in page headers and section bodies throughout entity detail pages.
 */
export default function EntityLinkButton({ label, onClick, color, className = '', requireModule }: EntityLinkButtonProps) {
  const targetEnabled = useIsModuleEnabled(requireModule ?? '');
  const c = COLOR_CLASSES[color];
  // When a target module is specified and disabled, the link (and its data) is suppressed.
  if (requireModule && !targetEnabled) return null;
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 ${c.bg} ${c.text} ${c.hover} transition-colors ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />
      {label} &rarr;
    </button>
  );
}
